<template>
    <div class="card" id="entry_pay">
        <div class="card-header">
            Withdrawal Limit ($)
        </div>
        <div class="card-body">
            <form class="form-horizontal form-materia" @submit.prevent="submit">
                <div class="form-group row">
                    
                    <div class="col-md-6"><label class="">Min Withdrawal</label>
                        <input type="text" v-model="form.minimum_withdrawal" class="form-control form-control-line">
                        <span class="text-danger" v-if="errors.minimum_withdrawal">{{errors.minimum_withdrawal}}</span>
                    </div>
                    
                    <div class="col-md-6"><label class="">Max Withdrawal</label>
                        <input type="text" v-model="form.maximum_withdrawal" class="form-control form-control-line">
                        <span class="text-danger" v-if="errors.maximum_withdrawal">{{errors.maximum_withdrawal}}</span>
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-sm-6 offset-md-2">
                        <span class="btn btn-success" v-if="processing">...</span>
                        <button v-else class="btn btn-success"><i class="icon-save mr-2"></i>Update</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {mapActions,mapState} from 'vuex'
import toastr from 'toastr'
export default {
    name:'withdrawal-limit',
    props:{
        systemSettings:{
            type:Object,
            required:true
        }
    },
    data(){
        return {
            form:{
                minimum_withdrawal:this.systemSettings. minimum_withdrawal,
                maximum_withdrawal:this.systemSettings. maximum_withdrawal,
            },
            errors:{
                maximum_withdrawal:null,
                minimum_withdrawal:null
            }
        }
    },

    computed:{
        ...mapState({
            processing:state=>state.processing
        })
    },

    methods:{
        ...mapActions('adminStore',['updateSettings']),
        submit(){
            this.updateSettings({data:this.form,field:'Withdrwal limit'}).catch(err=>{
                if (err.response && err.response.status === 422) {
                    this.errors = err.response.data.errors;
                    toastr.warning("Ivalid input")
                    console.log("error-" + JSON.stringify(err.response.data));
                }else{
                     toastr.error("An error occured while updating withdrawal limit")
                }
                this.$store.commit('processed',null,{root:true})
            })
        }
    }
}
</script>